import React from "react";

const priorityStyles = {
  Critical: "bg-rose-100 text-rose-800 border-rose-300",
  High: "bg-red-50 text-red-700 border-red-200",
  Medium: "bg-orange-50 text-orange-700 border-orange-200",
  Low: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

function PriorityBadge({ priority }) {
  const style =
    priorityStyles[priority] || "bg-gray-100 text-gray-700 border-gray-200";

  return (
    <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${style}`}>
      {priority}
    </span>
  );
}

export default PriorityBadge;
